<template>
    <span class="status-badge" :class="statusClass">{{ label }}</span>
</template>

<script>
import { useVehiclesLiveStore } from '@/stores/vehiclesLive'

export default {
    name: 'VehicleOnlineStatusBadge',
    props: {
        isOnline: {
            default: null,
            validator: (value) => value === null || typeof value === 'boolean',
        },
    },
    setup() {
        const vLive = useVehiclesLiveStore()

        return { vLive }
    },
    computed: {
        statusClass() {
            return this.vLive.onlineStatusClass(this.isOnline)
        },
        label() {
            const labelKey = this.vLive.onlineStatusLabelKey(this.isOnline)
            return labelKey ? this.$t(labelKey) : 'n/a'
        },
    },
}
</script>

<style scoped>
.status-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.status-badge--online {
    background: #22c55e;
    color: #ffffff;
}

.status-badge--offline {
    background: #ef4444;
    color: #ffffff;
}

.status-badge--unknown {
    background: #6b7280;
    color: #ffffff;
}
</style>
